(function () {
    'use strict';

    angular
        .module('app.checklists')
        .controller('ChecklistDetailController', ChecklistDetailController);

    ChecklistDetailController.$inject = [
        '$state', '$stateParams',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function ChecklistDetailController($state, $stateParams,
        bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;

        vm.cancel = cancel;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.submitForm = submitForm;
        vm.isNew = isNew;

        activate();

        function activate() {
            common.checkIsAdmin();
            getItem();
        }

        function submitForm(valid) {
            save();
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            window.history.back();
        }

      
        function isNew() {
            var val = $stateParams.id; 
            return val === "0";
                
        }

        function getItem() {
            var val = $stateParams.id;

            return dataservice.getItem("api/Checklists/" + val)
                .then(function (data) {
                    if (data) {
                        if (data.data.ID == '0') {
                            vm.item = {};
                            vm.item.Active = 1;
                            vm.item.IsManaged = false;
                            common.setAuditInfo(vm.item);
                        }
                        else {
                            vm.item = data.data;
                            common.setAuditInfo(vm.item);
                            common.convertDateStringsToDates(vm.item);
                            
                        }
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function save() {
            vm.isSaving = true;
            dataservice.saveItem('api/Checklists', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                common.notifier.notify(common.config.events.refreshCounts);
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });
        }
    }
})();

/*
Trix.config.textAttributes.color = {
    style: { color: "red" },
    parser: function (element) {
        console.log(element);
        return element.style.color === "red"
    },
    inheritable: true
}

Trix.config.textAttributes.comic = {
    style: { fontFamily: "Comic Sans MS" },
    parser: function (element) {
        return element.style.fontFamily.match(/Comic Sans MS/)
    },
    inheritable: true
}

addEventListener("trix-initialize", function (event) {
    var buttonHTML = '<button type="button" colorpicker class="trix-button" data-trix-attribute="color"><i class="glyphicon glyphicon-tint" /></button>'

    //buttonHTML += '<button type="button" >LOL</button>'

    event.target.toolbarElement.
        querySelector(".trix-button-group--text-tools").
        insertAdjacentHTML("beforeend", buttonHTML)
})

*/